import { render, staticRenderFns } from "./data-privacy-policy.vue?vue&type=template&id=48db77fb"
import script from "./data-privacy-policy.vue?vue&type=script&lang=js"
export * from "./data-privacy-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotInternal: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Internal/Internal.vue').default})
